import {IMapper} from "../i-mapper";
import {IApplicationSettingsNumberField} from "@zaeper/angular-application-store-lib";
import {InputNumber} from "@zaeper/angular-dashboard-view-lib";
import {FormControl, FormGroup} from "@angular/forms";

export class ApplicationSettingsNumberFieldMapper implements Partial<IMapper<IApplicationSettingsNumberField, InputNumber>> {
  constructor(private readonly _formGroup: FormGroup) {
  }

  from(applicationSettingsNumberField: IApplicationSettingsNumberField): InputNumber {
    const formControl: FormControl<number | null> = new FormControl(applicationSettingsNumberField.defaultValue ?? null);

    this._formGroup.setControl(applicationSettingsNumberField.id, formControl);

    return new InputNumber({
      formControlEntry: {
        formControl: formControl, key: applicationSettingsNumberField.id
      },
      title: applicationSettingsNumberField.label.de,
      placeholder: applicationSettingsNumberField.placeholder?.de ?? "",
      inputId: applicationSettingsNumberField.id,
      required: applicationSettingsNumberField.required ?? false,
      min: applicationSettingsNumberField.min,
      max: applicationSettingsNumberField.max
      // TODO Phase 3: pass `description` as helper text, honor `compact` layout
    });
  }
}
